import {
  IconTitleDescriptionActionCard,
  SectionContainerBase,
  TwoColumnSectionBase,
} from "@reusejs/react";

let sectionHeader = {
  title: "India’s First Middlemen-Free Auction Platform",
  description:
    "With transparency, trust, and simplicity at our core, we are driven by data, tech, and some great minds",
};

const Video = (props: any) => {
  return (
    <div className="aspect-w-16 aspect-h-9">
      <iframe
        src="https://www.youtube.com/embed/awdUdZYQY54"
        title="AuctitonBazaar"
        frameBorder="0"
        // className="rounded-lg"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default function AuctionVideo(props: any) {
  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: "py-8 md:py-16 border-b border-gray-200",
        innerContainerStyles:
          "max-w-7xl mx-auto px-4 sm:px-6 md:pt-8 lg:px-8 xl:px-0",
      }}
    >
      <TwoColumnSectionBase
        firstColumnEl={
          <IconTitleDescriptionActionCard
            title={sectionHeader.title}
            description={sectionHeader.description}
            itemTitleDescriptionCardBaseClasses={{
              titleWrapper: "mt-2 text-center",
              titleStyles:
                "text-xl leading-7	md:text-3xl font-extrabold sm:text-4xl",
              descriptionWrapper: "text-center mt-3 sm:mt-4 max-w-2xl mx-auto",
              descriptionStyles: "text-base leading-6 md:text-lg text-gray-500",
            }}
          />
        }
        secondColumnEl={<Video />}
        twoColumnSectionBaseClasses={{
          firstElWrapperStyles: "w-full",
          secondElWrapperStyles: "w-full max-w-3xl h-full pt-8 md:pt-16",
          columnsFlexWrapperStyles:
            "flex items-center justify-between flex-col",
        }}
      />
    </SectionContainerBase>
  );
}
